import request from '@/utils/comfyUiRequest'

export function genPrompt(data) {
  return request({
    url: 'prompt',
    method: 'post',
    data
  })
}

/**
 * 通过promptId获取图片路径
 *
 * @param {*} promptId
 * @returns
 */
export function getImagePathByPrompt(promptId) {
  return request({
    url: `history/${promptId}`,
    method: 'get'
  })
}
